import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderMonitorClusterMessageEncoder } from "../../encoder/OrderMonitorClusterMessageEncoder";

import * as CubiqTS from "../../index";

export class OrderMonitorClusterMessage extends ConcreteEncodable {
  public static enType: string = "com.bcdfx.monitor.api.OrderMonitorClusterMessage";

  /*FID=1*/
  public methodName: CubiqTS.RemoteMethod;
  /*FID=2*/
  public params: Array<CubiqTS.Encodable> | null = null;
  /*FID=100*/
  public messageId: string;

  constructor() {
    super();
    this.encoder = OrderMonitorClusterMessageEncoder.Instance;
    this.setEncodableType(OrderMonitorClusterMessage.enType);
    //Model
  }

  public toString(): string {
    return (
      "OrderMonitorClusterMessage[" +
      "methodName=" +
      this.methodName +
      "params=" +
      this.params +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
